import appLogger from "../utils/app-logger";
import { apiService } from "./base-api-service";
import { endPoints, getAssessmentServiceEndPoint } from "./api-constants";

class AssessmentService {
  AssessmentService(url) {
    return getAssessmentServiceEndPoint(url);
  }
  //START REGION :: ASSESSMENT RELATED
  getBulkQuestion(id, languageCode, customField) {
    appLogger.log("inside questionBulkMap ");
    let questionBulkMapEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.QUESTION_BULK_MAP.replace(
        ":assessmentid",
        id,
      )}`,
    );
    const params = new URLSearchParams();
    if (languageCode) params.append("locale", languageCode);
    if (customField) params.append("customField", customField);
    const queryString = params.toString();
    if (queryString) {
      questionBulkMapEndpoint = `${questionBulkMapEndpoint}?${queryString}`;
    }

    return apiService.get(questionBulkMapEndpoint);
  }

  //START REGION :: ASSESSMENT RELATED
  getOneQuestionPerAssessment(assesmentIds, languageCode) {
    appLogger.log("inside questionBulkMap ");
    let getOneQuestionPerAssessmentEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ONE_QUESTION_PER_ASSESSMENT}`,
    );
    if (languageCode) {
      getOneQuestionPerAssessmentEndpoint =
        getOneQuestionPerAssessmentEndpoint + `?locale=${languageCode}`;
    }
    return apiService.post(getOneQuestionPerAssessmentEndpoint, assesmentIds);
  }

  getCareerContent(personalityId) {
    // Correctly replace the placeholder with the actual personalityId
    const careerContentEndpoint = this.AssessmentService(
      endPoints.assessmentService.CAREER_CONTENT.replace(
        "{personalityId}",
        personalityId,
      ),
    ); // Log the constructed endpoint for debugging

    return apiService.get(careerContentEndpoint);
  }

  createUserAnswer(data) {
    appLogger.log("inside createUserAnswer");
    const createUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_USER_ANSWER}`,
    );
    return apiService.post(createUserAnswerEndpoint, data);
  }

  updateUserAnswer(data) {
    appLogger.log("inside updateUserAnswer");
    const updateUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_ANSWER}`,
    );
    return apiService.put(updateUserAnswerEndpoint, data);
  }

  getUserAnswerByAssessmentAttemptIdAndQuestionId(
    assessmentAttemptId,
    questionId,
  ) {
    appLogger.log("inside getUserAnswerByAssessmentAttemptIdAndQuestionId");
    const getUserAnswerByAssessmentAttemptIdAndQuestionIdEndpoint =
      this.AssessmentService(
        `${endPoints.assessmentService.GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID_QUESTIONID}`
          .replace("{assessmentAttemptId}", assessmentAttemptId)
          .replace("{questionId}", questionId),
      );
    return apiService.get(
      getUserAnswerByAssessmentAttemptIdAndQuestionIdEndpoint,
    );
  }

  getUserAnswerByAssessmentAttemptId(assessmentAttemptId) {
    appLogger.log("inside getUserAnswerByAssessmentAttemptIdAndQuestionId");
    const getUserAnswerByAssessmentAttemptId = this.AssessmentService(
      `${endPoints.assessmentService.GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID}`.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId,
      ),
    );
    return apiService.get(getUserAnswerByAssessmentAttemptId);
  }

  saveAssessmentResult(assessmentAttemptId, userGuid) {
    appLogger.log("inside saveAssessmentResult");
    let saveAssessmentResultEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.SAVE_ASSESSMENT_RESULT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId,
      )}`,
    );
    if (userGuid) {
      saveAssessmentResultEndpoint =
        saveAssessmentResultEndpoint + "?userGuid=" + userGuid;
    }
    return apiService.post(saveAssessmentResultEndpoint, assessmentAttemptId);
  }

  getAssessmentResultByAssessmentAttemptId(assessmentAttemptId, languageCode) {
    appLogger.log("inside getAssessmentAttemptByAssessmentId");

    let getAssessmentResulttByAssessmentAttemptIdEndpoint =
      this.AssessmentService(
        `${endPoints.assessmentService.GET_ASSESSMENT_RESULT}`.replace(
          "{assessmentAttemptId}",
          assessmentAttemptId,
        ),
      );
    if (languageCode) {
      getAssessmentResulttByAssessmentAttemptIdEndpoint =
        getAssessmentResulttByAssessmentAttemptIdEndpoint +
        "?locale=" +
        languageCode;
    }

    return apiService.get(
      getAssessmentResulttByAssessmentAttemptIdEndpoint,
      null,
    );
  }

  getAssessmentAttempt(userGuid, assessmentAttemptId) {
    appLogger.log("inside assessment attempt ");
    const assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ASSESSMENT_ATTEMPT.replace(
        "{userGuid}",
        userGuid,
      ).replace("{assessmentAttemptId}", assessmentAttemptId)}`,
    );
    return apiService.get(assessmentAttemptEndpoint);
  }

  updateUserEmail(data) {
    appLogger.log("update email id");
    const assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_EMAIL}`,
    );
    return apiService.patch(assessmentAttemptEndpoint, data);
  }

  getAssessmentAttemptByUserId(userGuid, languageCode) {
    appLogger.log("inside assessment attempt ");
    let assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ASSESSMENT_ATTEMPT_BY_USERID.replace(
        "{userGuid}",
        userGuid,
      )}`,
    );
    if (languageCode) {
      assessmentAttemptEndpoint =
        assessmentAttemptEndpoint + "?locale=" + languageCode;
    }

    return apiService.get(assessmentAttemptEndpoint, null);
  }

  getAssessment(languageCode) {
    appLogger.log("inside assessment id ");
    let assessment = this.AssessmentService(
      `${endPoints.assessmentService.GET_ALL_ASSESSMENT_}`,
    );
    if (languageCode) {
      assessment = assessment + "?locale=" + languageCode;
    }

    return apiService.get(assessment, null);
  }

  createAssessmentAttempt(data) {
    appLogger.log("inside createAssessmentAttempt ");
    const createAssessmentAttemptEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_ASSESSMENT_ATTEMPT,
    );

    return apiService.post(createAssessmentAttemptEndpoint, data);
  }

  updateAssessmentAttempt(data) {
    appLogger.log("inside updateAssessmentAttempt ");
    const updateAssessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_ASSESSMENT_ATTEMPT}`,
    );
    return apiService.put(updateAssessmentAttemptEndpoint, data);
  }

  downloadAssessmentResult(userGUID, assessmentAttemptId, languageCode) {
    let downloadAssessmentEndpoint = this.AssessmentService(
      endPoints.assessmentService.DOWNLOAD_ASSESSMENT_RESULT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId,
      ).replace("{userGuid}", userGUID),
    );
    if (languageCode) {
      downloadAssessmentEndpoint =
        downloadAssessmentEndpoint + `?locale=${languageCode}`;
    }

    return apiService.get(downloadAssessmentEndpoint);
  }

  viewAssessmentReport(userGUID, assessmentAttemptId, locale) {
    let viewAssessmentReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.VIEW_ASSESSMENT_REPORT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId,
      ).replace("{userGuid}", userGUID),
    );
    if (locale) {
      viewAssessmentReportEndpoint =
        viewAssessmentReportEndpoint + "?locale=" + locale;
    }
    return apiService.get(viewAssessmentReportEndpoint);
  }

  //END REGION :: ASSESSMENT RELATED

  //START REGION :: USER + AUTH RELATED
  createUser(data) {
    appLogger.log("inside createUser ");
    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_USER}`,
    );
    return apiService.post(createUserEndpoint, data);
  }

  createExternalUser(data) {
    appLogger.log("inside ExternalCreateUser ");
    const createExternalUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_EXTERNAL_USER}`,
    );
    return apiService.post(createExternalUserEndpoint, data);
  }

  AuthenticateUser(data) {
    appLogger.log("inside AuthenticateUser ");
    const authEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.USER_AUTH}`,
    );
    return apiService.post(authEndpoint, data);
  }

  loginAsAdmin(data) {
    appLogger.log("inside loginAsAdmin ");
    const loginAsAdminEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.LOGIN_AS_ADMIN}`,
    );
    return apiService.post(loginAsAdminEndpoint, data);
  }

  AuthenticateExternalUser(data) {
    appLogger.log("inside AuthenticateUser ");
    const authEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.EXTERNAL_USER_AUTH}`,
    );
    return apiService.post(authEndpoint, data);
  }

  loginUser(Username) {
    const loginEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.USER_LOGIN}`,
    );
    const encodedUserName = encodeURIComponent(Username);
    return apiService.get(
      `${loginEndpoint}?username=${encodedUserName}&email=${encodedUserName}`,
    );
  }

  searchUserByEmailAndAccountNumber(data) {
    const loginEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.SEARCH_USER_BY_EMAIL_ACCOUNT_NUMBER}`,
    );
    const encodedUserName = encodeURIComponent(data.email);
    if (data.accountNumber) {
      return apiService.get(
        `${loginEndpoint}?accountNumber=${data.accountNumber}`,
      );
    } else if (data.email) {
      return apiService.get(`${loginEndpoint}?email=${encodedUserName}`);
    } else if (data.userId) {
      return apiService.get(`${loginEndpoint}?userId=${data.userId}`);
    } else {
      console.error("Either accountNumber, email, or userId is required.");
      return null;
    }
  }

  updateUserId(data) {
    const updateUserIdInUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USERID}`,
    );

    return apiService.put(updateUserIdInUserAnswerEndpoint, data);
  }

  getUserById(userGuid) {
    appLogger.log("inside getUserById ");

    // Replace ":userid" with the actual userGUID in the endpoint
    const userEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_BY_ID.replace("{userid}", userGuid),
    );

    return apiService.get(userEndPoint, null);
  }

  forgotPassword(data) {
    appLogger.log("inside forgotPassword ");
    const forgotPasswordEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.FORGOT_PASSWORD}`,
    );
    return apiService.patch(forgotPasswordEndpoint, data);
  }

  resetPassword(data) {
    appLogger.log("inside resetPassword ");
    const resetPasswordEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.RESET_PASSWORD}`,
    );
    return apiService.post(resetPasswordEndpoint, data);
  }

  changePassword(data) {
    const changePasswordEndPoint = this.AssessmentService(
      endPoints.assessmentService.CHANGE_PASSWORD,
    );
    return apiService.post(changePasswordEndPoint, data);
  }

  updateUser(data) {
    const updateUserEndpoint = this.AssessmentService(
      endPoints.assessmentService.UPDATE_USER,
    );
    return apiService.put(updateUserEndpoint, data);
  }

  isAdminUser(data) {
    const updateUserEndpoint = this.AssessmentService(
      endPoints.assessmentService.IS_ADMIN,
    );
    return apiService.post(updateUserEndpoint, data);
  }

  //END REGION :: USER + AUTH RELATED

  //START REGION : PAYMENT RELATED

  getPlans(data) {
    appLogger.log("inside createPayment ");

    const getPlansEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_PLANS}`,
    );
    return apiService.post(getPlansEndpoint, data);
  }

  createPaymentIntent(data) {
    appLogger.log("inside createPaymentIntent ");

    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_PAYMENT_INTENT}`,
    );
    return apiService.post(createUserEndpoint, data);
  }

  createWalletPaymentIntent(data) {
    appLogger.log("inside createWalletPaymentIntent ");

    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_WALLET_PAYMENT_INTENT}`,
    );
    return apiService.post(createUserEndpoint, data);
  }

  doCheckout(data) {
    appLogger.log("inside doCheckout ");

    let createPaymentEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.DO_CHECKOUT}`,
    );
    if (data?.locale) {
      createPaymentEndpoint = createPaymentEndpoint + "?locale=" + data?.locale;
    }

    return apiService.post(createPaymentEndpoint, data);
  }

  updateConfirmation(data) {
    const { userGuid } = data;

    appLogger.log("inside confirmation");
    const confirmationEndPoint = this.AssessmentService(
      endPoints.assessmentService.CONFIRMATION.replace("{userGuid}", userGuid),
    );

    return apiService.put(confirmationEndPoint, data);
  }

  accountCancellation(data) {
    let accountCancellationEndPoint = this.AssessmentService(
      endPoints.assessmentService.ACCOUNT_CANCELLATION.replace(
        "{userGuid}",
        data?.userGuid,
      ),
    );
    if (data?.locale) {
      accountCancellationEndPoint =
        accountCancellationEndPoint + `?locale=${data?.locale}`;
    }

    return apiService.put(accountCancellationEndPoint, data);
  }

  // Submit cancellation feedback
  cancellationFeedback(data) {
    const cancellationFeedbackEndpoint = this.AssessmentService(
      endPoints.assessmentService.CANCELLATION_FEEDBACK,
    );
    return apiService.post(cancellationFeedbackEndpoint, data);
  }

  getTransactionDetail(userGuid) {
    const getTransactionDetailEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_TRANSACTION_DETAILS.replace(
        "{userguid}",
        userGuid,
      ),
    );
    return apiService.get(getTransactionDetailEndPoint, null);
  }

  getOrderDataByUserId(userGuid) {
    const getOrderDataEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_ORDER_DATA_BY_USERID.replace(
        "{userId}",
        userGuid,
      ),
    );
    return apiService.get(getOrderDataEndPoint, null);
  }

  getBilling(data) {
    const { transId, skuGuid, locale } = data;
    const getBillingEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_BILLING.replace("{transId}", transId)
        .replace("{skuGuid}", skuGuid)
        .replace("{locale}", locale),
    );
    return apiService.get(getBillingEndPoint, null);
  }

  getGuestUser(parentGuid) {
    const getGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_GUEST_USER.replace(
        "{parentGuid}",
        parentGuid,
      ),
    );
    return apiService.get(getGuestUserEndPoint, null);
  }

  createGuestUser(data) {
    const createGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_GUEST_USER,
    );
    return apiService.post(createGuestUserEndPoint, data);
  }

  addGuestUsersBulk(data) {
    const endpoint = this.AssessmentService(
      endPoints.assessmentService.ADD_GUEST_USERS_BULK,
    );
    return apiService.post(endpoint, data);
  }

  saveUserSocialButtonClick(data) {
    const saveUserSocialButtonClickEndPoint = this.AssessmentService(
      endPoints.assessmentService.SAVE_USER_SOCIAL_BUTTON_CLICK,
    );
    return apiService.post(saveUserSocialButtonClickEndPoint, data);
  }

  updateGuestUser(data) {
    const updateGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.UPDATE_GUEST_USER,
    );
    return apiService.put(updateGuestUserEndPoint, data);
  }

  getPaymentProcessors() {
    const paymentProcessorEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_PAYMENT_PROCESSOR_LIST,
    );
    return apiService.get(paymentProcessorEndpoint, null);
  }

  updatePaymentProcessorDetails(data) {
    const updatePaymentProcessor = this.AssessmentService(
      endPoints.assessmentService.UPDATE_PAYMENT_PROCESSOR,
    );
    return apiService.put(updatePaymentProcessor, data);
  }

  decryptURL(token) {
    const decryptURLEndPoint = this.AssessmentService(
      endPoints.assessmentService.DECRYPTURL.replace("{token}", token),
    );
    return apiService.post(decryptURLEndPoint, token);
  }

  isGuestOrPremiumUser(userGuid) {
    const isGuestOrPremiumUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.IS_GUEST_OR_PREMIUM_USER.replace(
        "{userGuid}",
        userGuid,
      ),
    );
    return apiService.get(isGuestOrPremiumUserEndPoint, null);
  }

  getContentLatestVersion(data) {
    const { modelType, contentKey } = data;

    const getLatestVersionEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_LATEST_VERSION.replace(
        "{modelType}",
        modelType,
      ).replace("{contentKey}", contentKey),
    );
    return apiService.get(getLatestVersionEndpoint);
  }

  getAssessmentByAssessmentId(id) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_ASSESSMENT_BY_ASSESSMENTID.replace(
        "{assessmentId}",
        id,
      ),
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  createContentMap(data) {
    const createContentMapEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_CONTENT_MAP.replace(
        "{userguid}",
        data.userGuid,
      ),
    );
    return apiService.post(createContentMapEndpoint, data);
  }

  shareReportOnEmail(data) {
    let shareReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.SHARE_REPORT_ON_EMAIL.replace(
        "{userid}",
        data.userGuid,
      ).replace("{assessmentAttemptId}", data.assessmentAttemptId),
    );

    if (data?.locale) {
      shareReportEndpoint = shareReportEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(shareReportEndpoint, data);
  }

  deleteReport(data) {
    const deleteReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.DELETE_REPORT,
    );
    return apiService.delete(deleteReportEndpoint, data);
  }

  getInsightfulContent(data) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_INSIGHTFUL_CONTENT.replace(
        "{modelType}",
        data.modelType,
      ).replace("{contentKey}", data.contentKey),
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  getAbTest(data) {
    const abTestEndpoint = this.AssessmentService(
      endPoints.assessmentService.AB_TEST,
    );
    return apiService.post(abTestEndpoint, data);
  }
  fetchABTest(data) {
    const abTestEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_AB_TEST,
    ).replace("{abtestId}", data.abtestId);
    return apiService.get(abTestEndpoint, data);
  }

  sendToFriendReportOnEmail(data) {
    const { selfUserId } = data;

    let sendToFriendReportOnEmailEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_TO_FRIEND.replace(
        "{userGuid}",
        selfUserId,
      ),
    );
    if (data?.locale) {
      sendToFriendReportOnEmailEndpoint =
        sendToFriendReportOnEmailEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(sendToFriendReportOnEmailEndpoint, data);
  }

  sendToPartnerReportOnEmail(data) {
    const { selfUserId } = data;

    let sendToPartnerReportOnEmailEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_TO_PARTNER.replace(
        "{userGuid}",
        selfUserId,
      ),
    );
    if (data?.locale) {
      sendToPartnerReportOnEmailEndpoint =
        sendToPartnerReportOnEmailEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(sendToPartnerReportOnEmailEndpoint, data);
  }

  sendRefundRequest(userGuid) {
    const sendRefundRequestEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_REFUND_REQUEST.replace(
        "{userGuid}",
        userGuid,
      ),
    );
    return apiService.post(sendRefundRequestEndpoint, userGuid);
  }

  accountReActivate(data) {
    const accountReActivateEndpoint = this.AssessmentService(
      endPoints.assessmentService.ACCOUNT_REACTIVATE,
    );
    return apiService.put(accountReActivateEndpoint, data);
  }

  userMetaDetails(data) {
    const userMetaDetailsEndpoint = this.AssessmentService(
      endPoints.assessmentService.USER_META,
    );
    return apiService.post(userMetaDetailsEndpoint, data);
  }

  bulkReactivate(data) {
    const accountReActivateEndpoint = this.AssessmentService(
      endPoints.assessmentService.BULK_ACCOUNT_REACTIVATE,
    );
    return apiService.post(accountReActivateEndpoint, data);
  }

  submitSurveyFeedback(data) {
    const submitSurveyFeedbackEndpoint = this.AssessmentService(
      endPoints.assessmentService.SURVEY_FEEDBACK,
    );
    return apiService.post(submitSurveyFeedbackEndpoint, data);
  }

  createAssessmentMap(data) {
    appLogger.log("inside createAssessmentAttempt ");
    const createAssessmentMapEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_ASSESSMENT_MAP,
    );

    return apiService.post(createAssessmentMapEndpoint, data);
  }

  isCompleteRomanticCompatibility(assessmentMapId) {
    appLogger.log("inside isCompleteRomanticCompatibility ");
    const isCompleteRomanticCompatibilityEndpoint = this.AssessmentService(
      endPoints.assessmentService.IS_COMPLETE_ROMANTIC_COMPATIBILITY.replace(
        "{assessmentMapId}",
        assessmentMapId,
      ),
    );

    return apiService.get(isCompleteRomanticCompatibilityEndpoint);
  }

  createGuestUserWithoutEmail(data) {
    const createGuestUserWithoutEmailEndPoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_GUEST_USER_WITHOUT_EMAIL,
    );
    return apiService.post(createGuestUserWithoutEmailEndPoint, data);
  }

  saveRelationshipCompatibilityResult(assessmentMapId) {
    appLogger.log("inside saveRelationshipCompatibilityResult ");
    const saveRelationshipCompatibilityResultEndpoint = this.AssessmentService(
      endPoints.assessmentService.SAVE_RELATIONSHIP_COMPATIBILITY_RESULTS.replace(
        "{assessmentMapId}",
        assessmentMapId,
      ),
    );
    return apiService.post(
      saveRelationshipCompatibilityResultEndpoint,
      assessmentMapId,
    );
  }

  saveUserAssessmentResultMaps(data) {
    appLogger.log("inside saveUserAssessmentResultMap ");
    const saveUserAssessmentResultMapsEndpoint = this.AssessmentService(
      endPoints.assessmentService.USER_ASSESSMENT_RESULT_MAP,
    );
    return apiService.post(saveUserAssessmentResultMapsEndpoint, data);
  }

  getUserAssessmentResultMapByUserId(userId) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_ASSESSMENT_RESULT_MAP.replace(
        "{userId}",
        userId,
      ),
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  getUserAssessmentResultByResultId(id, locale) {
    let getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_ASSESSMENT_RESULT_BY_RESULT_ID.replace(
        "{id}",
        id,
      ),
    );
    if (locale) {
      getAssessmentByIdEndpoint =
        getAssessmentByIdEndpoint + `?locale=${locale}`;
    }
    return apiService.get(getAssessmentByIdEndpoint);
  }

  updateUserPassword(data) {
    appLogger.log("update password");
    const userPasswordUpdateEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_PASSWORD}`,
    );
    return apiService.patch(userPasswordUpdateEndpoint, data);
  }

  getBadges({ badgeType, currentLocale }) {
    let endpoint = endPoints.assessmentService.GET_ALL_BADGES;
    if (badgeType) {
      endpoint = endpoint.replace("{badgeType}", encodeURIComponent(badgeType));
    } else {
      endpoint = endpoint.replace("?badgeType={badgeType}", "");
    }
    if (currentLocale) {
      const separator = endpoint.includes("?") ? "&" : "?";
      endpoint = `${endpoint}${separator}locale=${encodeURIComponent(currentLocale)}`;
    }
    const getBadgesEndpoint = this.AssessmentService(endpoint);
    return apiService.get(getBadgesEndpoint);
  }

  getUserSocialButtonClickByUserId(userId) {
    let endpoint =
      endPoints.assessmentService.GET_USER_SOCIAL_BUTTON_CLICK_BY_USER_ID;
    if (userId) {
      endpoint = endpoint.replace("{userId}", encodeURIComponent(userId));
    }
    const getUserSocialButtonClickByUserIdEndpoint =
      this.AssessmentService(endpoint);
    return apiService.get(getUserSocialButtonClickByUserIdEndpoint);
  }

  verifyCapchaToken(data) {
    appLogger.log("inside verify capcha token ");
    const requestData = {
      greToken: data?.greToken,
    };
    const verifyCapchaTokenEndpoint = this.AssessmentService(
      endPoints.assessmentService.VERIFY_CAPCHA_TOKER.replace(
        "{portal}",
        data.portal,
      ),
    );
    return apiService.post(verifyCapchaTokenEndpoint, requestData);
  }

  loginAttempt(data) {
    appLogger.log("inside loginAttempt ");
    const loginAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.LOGIN_ATTEMPT}`,
    );
    return apiService.post(loginAttemptEndpoint, data);
  }

  updateUserPlan(data) {
    const updateUserPlanEndpoint = this.AssessmentService(
      endPoints.assessmentService.UPDATE_USER_PLAN,
    );
    return apiService.put(updateUserPlanEndpoint, data);
  }

  getPaypalAccessToken(userGUID) {
    appLogger.log("inside getPaypalAccessToken ");
    const paypalAccessTokenEndpoint = this.AssessmentService(
      endPoints.assessmentService.PAYPAL_ACCESS_TOKEN.replace(
        "{userguid}",
        userGUID,
      ),
    );
    return apiService.post(paypalAccessTokenEndpoint, {});
  }

  createHmac(data) {
    appLogger.log("inside createHmac ");
    const createHmacEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_HMAC,
    );
    return apiService.post(createHmacEndpoint, data);
  }

  //START REGION :: IP CONFIG RELATED
  getIPConfig(ipAddress) {
    appLogger.log("inside getIPConfig ");
    const getIPConfigEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_IP_CONFIG,
    );
    if (!!ipAddress) {
      return apiService.get(
        `${getIPConfigEndpoint}?ipAddress=${encodeURIComponent(ipAddress)}`,
      );
    }
    return apiService.get(getIPConfigEndpoint);
  }
  //END REGION :: IP CONFIG RELATED

  // updateEmail(userId) {
  //   const updateEmailEndpoint = this.AssessmentService(endPoints.assessmentService.UPDATE_USER_EMAIL);
  //   return apiService.put(updateEmailEndpoint, userId);
  // }

  //END REGION
}

export default new AssessmentService();
